export default __webpack_public_path__ + "static/media/nav_book.224174f6.svg";